import React from 'react';
import moment from 'moment';
import { TabPane, Row, Col } from 'reactstrap';
import {
  FUEL_TYPE_ELECTRICITY,
  FUEL_TYPE_GAS,
} from '../../config/AppConfigurator';
import { isEmpty } from '../../utils/utils';
import PropTypes from 'prop-types';

export const QueryDetailFields = ({ queryType, detail = null, index }) => {
  return (
    <>
      <TabPane key={index} tabId={index.toString()}>
        <Row>
          <Col sm='12'>
            <div className='mb-3'>
              <label htmlFor='InputMeterSerialNumber' className='form-label'>
                Meter Serial Number
              </label>
              <input
                type='text'
                disabled
                className='form-control'
                value={
                  isEmpty(detail) || detail.meterSerialNumber === null
                    ? 'N/A'
                    : detail.meterSerialNumber
                }
                id='InputMeterSerialNumber'
                aria-describedby='MeterSerialNumberHelp'
              />
            </div>
            <div className='mb-3'>
              <label
                htmlFor='InputCurrentEnergySupplier'
                className='form-label'
              >
                Current Energy Supplier
              </label>
              <input
                type='text'
                disabled
                className='form-control'
                value={
                  isEmpty(detail) || detail.currentSupplierName === null
                    ? 'N/A'
                    : detail.currentSupplierName
                }
                id='InputCurrentEnergySupplier'
                aria-describedby='CurrentEnergySupplierHelp'
              />
            </div>
            {queryType === FUEL_TYPE_GAS && (
              <div className='mb-3'>
                <label
                  htmlFor='InputPreviousEnergySupplier'
                  className='form-label'
                >
                  Previous Energy Supplier
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.previousSupplierName === null
                      ? 'N/A'
                      : detail.previousSupplierName
                  }
                  id='InputPreviousEnergySupplier'
                  aria-describedby='PreviousEnergySupplierHelp'
                />
              </div>
            )}
            <div className='mb-3'>
              <label htmlFor='InputMeterType' className='form-label'>
                Meter Type
              </label>
              <textarea
                disabled
                className='form-control'
                value={
                  isEmpty(detail) || detail.meterTypeDescription === null
                    ? 'N/A'
                    : detail.meterTypeDescription
                }
                id='InputMeterType'
                aria-describedby='MeterTypeHelp'
              />
            </div>
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputMPAN' className='form-label'>
                  MPAN
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.mpan === null
                      ? 'N/A'
                      : detail.mpan
                  }
                  id='InputMPAN'
                  aria-describedby='MPANHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_GAS && (
              <div className='mb-3'>
                <label htmlFor='InputMPRN' className='form-label'>
                  MPRN
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.mprn === null
                      ? 'N/A'
                      : detail.mprn
                  }
                  id='InputMPRN'
                  aria-describedby='MPRNHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_GAS && (
              <div className='mb-3'>
                <label htmlFor='InputLastMeterReadDate' className='form-label'>
                  Last Meter Read Date
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.lastMeterReadDate === null
                      ? 'N/A'
                      : moment(detail.lastMeterReadDate, 'YYYYMMDD').format(
                          'MMM Do YYYY'
                        )
                  }
                  id='InputLastMeterReadDate'
                  aria-describedby='InputLastMeterReadDateHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_GAS && (
              <div className='mb-3'>
                <label htmlFor='InputLastMeterReadValue' className='form-label'>
                  Last Meter Read Value
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.lastMeterReadValue === null
                      ? 'N/A'
                      : detail.lastMeterReadValue
                  }
                  id='InputLastMeterReadValue'
                  aria-describedby='InputLastMeterReadValueHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_GAS && (
              <div className='mb-3'>
                <label htmlFor='InputAmrIndicator' className='form-label'>
                  AMR Indicator
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.amrIndicator === null
                      ? 'N/A'
                      : detail.amrIndicator
                  }
                  id='InputAmrIndicator'
                  aria-describedby='InputAmrIndicatorHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_GAS && (
              <div className='mb-3'>
                <label htmlFor='InputConsumption' className='form-label'>
                  Consumption
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.mpaq === null
                      ? 'N/A'
                      : detail.mpaq
                  }
                  id='InputConsumption'
                  aria-describedby='InputConsumptionHelp'
                />
              </div>
            )}
            <div className='mb-3'>
              <label
                htmlFor='InputCurrentEnergySupplierEffectiveDate'
                className='form-label'
              >
                Current Energy Supplier Effective Date
              </label>
              <input
                type='text'
                disabled
                className='form-control'
                value={
                  isEmpty(detail) || detail.supplierEfd === null
                    ? 'N/A'
                    : moment(detail.supplierEfd, 'YYYYMMDD').format(
                        'MMM Do YYYY'
                      )
                }
                id='InputCurrentEnergySupplierEffectiveDate'
                aria-describedby='CurrentEnergySupplierEffectiveDateHelp'
              />
            </div>
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputEnergyDirection' className='form-label'>
                  Energy Direction
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.energyDirection === null
                      ? 'N/A'
                      : detail.energyDirection === 'I'
                      ? 'Import'
                      : 'Export'
                  }
                  id='InputEnergyDirection'
                  aria-describedby='MeterEnergyDirectionHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputSSC' className='form-label'>
                  SSC
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.ssc === null ? 'N/A' : detail.ssc
                  }
                  id='InputSSC'
                  aria-describedby='MeterSSCHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputEconomy7' className='form-label'>
                  Economy 7
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.isEconomy7 === null
                      ? 'N/A'
                      : detail.isEconomy7
                      ? 'Yes'
                      : 'No'
                  }
                  id='InputEconomy7'
                  aria-describedby='MeterEconomy7Help'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputProfileClass' className='form-label'>
                  Profile Class
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.profileClass === null
                      ? 'N/A'
                      : detail.profileClass
                  }
                  id='InputProfileClass'
                  aria-describedby='MeterProfileClassHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputLineLossFactor' className='form-label'>
                  Line Loss Factor
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.lineLossFactor === null
                      ? 'N/A'
                      : detail.lineLossFactor
                  }
                  id='InputLineLossFactor'
                  aria-describedby='MeterLineLossFactorHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label
                  htmlFor='InputMeterTimeswitchClass'
                  className='form-label'
                >
                  Meter Time Switch Class
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.meterTimeswitchClass === null
                      ? 'N/A'
                      : detail.meterTimeswitchClass
                  }
                  id='MeterTimeswitchClass'
                  aria-describedby='MeterTimeswitchClassHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputMeteredIndicator' className='form-label'>
                  Meter Time Switch Class
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.meteredIndicator === null
                      ? 'N/A'
                      : detail.meteredIndicator
                  }
                  id='InputMeteredIndicator'
                  aria-describedby='MeteredIndicatorHelp'
                />
              </div>
            )}
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputTradingStatusEfd' className='form-label'>
                  Trading Status Effective Date
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.tradingStatusEfd === null
                      ? 'N/A'
                      : moment(detail.tradingStatusEfd, 'YYYYMMDD').format(
                          'MMM Do YYYY'
                        )
                  }
                  id='InputTradingStatusEfd'
                  aria-describedby='TradingStatusEfdHelp'
                />
              </div>
            )}
            <div className='mb-3'>
              <label htmlFor='InputMeterStatus' className='form-label'>
                Meter Status
              </label>
              <input
                type='text'
                disabled
                className='form-control'
                value={
                  isEmpty(detail) || detail.meterStatusDescription === null
                    ? 'N/A'
                    : detail.meterStatusDescription
                }
                id='InputMeterStatus'
                aria-describedby='MeterStatusHelp'
              />
            </div>
            <div className='mb-3'>
              <label htmlFor='InputIsDomestic' className='form-label'>
                Is Domestic
              </label>
              <input
                type='text'
                disabled
                className='form-control'
                value={
                  isEmpty(detail) || detail.isDomestic === null
                    ? 'N/A'
                    : detail.isDomestic
                    ? 'Yes'
                    : 'No'
                }
                id='InputIsDomestic'
                aria-describedby='InputIsDomesticHelp'
              />
            </div>
            <div className='mb-3'>
              <label htmlFor='InputIsPrepayment' className='form-label'>
                Is Prepayment
              </label>
              <input
                type='text'
                disabled
                className='form-control'
                value={
                  isEmpty(detail) || detail.isPrepayment === null
                    ? 'N/A'
                    : detail.isPrepayment
                    ? 'Yes'
                    : 'No'
                }
                id='InputIsPrepayment'
                aria-describedby='InputIsPrepaymentHelp'
              />
            </div>
            <div className='mb-3'>
              <label htmlFor='InputIsSmartMeter' className='form-label'>
                Is SmartMeter
              </label>
              <input
                type='text'
                disabled
                className='form-control'
                value={
                  isEmpty(detail) || detail.isSmartMeter === null
                    ? 'N/A'
                    : detail.isSmartMeter
                    ? 'Yes'
                    : 'No'
                }
                id='InputIsSmartMeter'
                aria-describedby='InputIsSmartMeterHelp'
              />
            </div>
            {queryType === FUEL_TYPE_ELECTRICITY && (
              <div className='mb-3'>
                <label htmlFor='InputCommercialSupply' className='form-label'>
                  Commercial Supply
                </label>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={
                    isEmpty(detail) || detail.isDomestic === null
                      ? 'N/A'
                      : detail.isDomestic
                      ? 'No'
                      : 'Yes'
                  }
                  id='InputCommercialSupply'
                  aria-describedby='CommercialSupplyHelp'
                />
              </div>
            )}
          </Col>
        </Row>
      </TabPane>
    </>
  );
};

QueryDetailFields.propTypes = {
  /* 
      query type for query detail component
    */
  queryType: PropTypes.number.isRequired,
  /* 
      detail for query detail component
    */
  detail: PropTypes.object.isRequired,
  /* 
      index for query detail component
    */
  index: PropTypes.number.isRequired,
};

QueryDetailFields.defaultProps = {
  /*
        default value if query type is not given
    */
  queryType: 0,
  /*
        default value if detail is not given
    */
  detail: {},
  /*
        default value if index is not given
    */
  index: 0,
};
